import api from './api';
import { PinSnapshot } from '../models';
import { getBackVersion } from '../config';

const getPins = (): Promise<PinSnapshot[]> => {
    return api.request<PinSnapshot[]>({
        method: 'GET',
        url: `${getBackVersion()}/account/pins`,
    });
};

/* eslint camelcase: 0 */
const createPin = (areaType: string, areaId: number): Promise<PinSnapshot> => {
    return api.request<PinSnapshot>({
        method: 'POST',
        url: `${getBackVersion()}/account/pins`,
        data: {
            area_type: areaType,
            area_id: areaId,
        },
    });
};

const removePin = (pinId: number): Promise<PinSnapshot> => {
    return api.request<PinSnapshot>({
        method: 'DELETE',
        url: `${getBackVersion()}/account/pins/` + pinId,
    });
};

const PinResource = {
    getPins,
    createPin,
    removePin,
};

export default PinResource;
